import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetTagsResponse
} from '@eggplant/types'
import type { SutCriteriaQuery } from './types'

interface Props {
  params?: SutCriteriaQuery
  onError?: (error: Error) => void
  onSuccess?: (response: GetTagsResponse) => void
  children?: (response: GetTagsResponse) => ReactElement
  shortErrorMessage?: string
}

const GetSutCriteriaRequest = ({
  params,
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const { requestParams } = useGetParamsWithSpaceId<SutCriteriaQuery|undefined>(params)

  const newParams = params?.sut_id
    ? params
    : requestParams

  const url = `${SUT_SERVICE}/criteria`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={newParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetSutCriteriaRequest
